import * as THREE from "three";

export default class BasePlane {
  constructor(experience) {
    this.experience = experience;
    this.scene = this.experience.scene;
    this.eventHub = this.experience.eventHub; // Reference for future event handling
    this.resources = this.experience.resources;

    this.init();
  }

  init() {
    this.createGeometry();
    this.createMaterial();
    this.createMesh();
  }

  /**
   * Creates the plane geometry and ensures it lays flat.
   */
  createGeometry() {
    this.geometry = new THREE.PlaneGeometry(1000, 1000);
    this.geometry.rotateX(-Math.PI / 2); // Correct orientation
  }

  /**
   * Creates an invisible material for the plane.
   */
  createMaterial() {
    this.material = new THREE.MeshBasicMaterial({
      visible: false,
      side: THREE.DoubleSide, // ✅ this enables raycasting from both sides
    });
  }
  

  /**
   * Combines geometry and material into a mesh and adds it to the scene.
   */
  createMesh() {
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.name = "BasePlane";
    this.mesh.position.set(0, 0, 0);
    this.scene.add(this.mesh);
  }

  /**
   * Disposes of the plane's geometry and material to free up memory.
   */
  dispose() {
    if (this.mesh) {
      this.scene.remove(this.mesh);
      this.mesh.geometry.dispose();
      this.mesh.material.dispose();
    }
  }
}
